import {useTranslation} from "react-i18next";

export const LanguageSelector = () =>
{
    const [t, i18n] = useTranslation('common');
    let currentLang = i18n.language;

    const handleLanguageChange = (e) => {
        const newLang = e.target.value;
        i18n.changeLanguage(newLang);
    };

    const handleLanguageClick = (newLang) => {
        currentLang = newLang;
        i18n.changeLanguage(newLang);
    };

    return (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle uppercase" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"> { currentLang }</a>
                <ul className="dropdown-menu dropdown-menu-right" role="menu">
                    <li><a className="dropdown-item" onClick={(e) => handleLanguageClick('fr') } href="#">{t('app.language.fr')}</a></li>
                    <li><a className="dropdown-item" onClick={(e) => handleLanguageClick('en') } href="#">{t('app.language.en')}</a></li>
                </ul>
            </li>
        </ul>
    )
}